import { render, staticRenderFns } from "./ListInstrTable.vue?vue&type=template&id=63ae8a78&scoped=true&"
import script from "./ListInstrTable.vue?vue&type=script&lang=js&"
export * from "./ListInstrTable.vue?vue&type=script&lang=js&"
import style0 from "./ListInstrTable.vue?vue&type=style&index=0&id=63ae8a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae8a78",
  null
  
)

export default component.exports